<template>
  <article :class="getRadius" class="article-block">
    <a href="/" :aria-label="aria">
      <figure class="article-block__image">
        <img :src="getImage" alt="Alt description for the image" />
      </figure>
      <div class="article-block__header">
        <h3 :class="{ headerVisible: isActive }">
          <TextHeading>{{ title }}</TextHeading>
        </h3>
      </div>
    </a>
    <div class="article-block__sharer">
      <span class="article-block__text">{{ date }}</span>
      <BaseButton
        class="article-block__button"
        variant="white"
        rounded="full"
        @click="toggleActive"
        aria-label="Share this News Article"
      >
        <BaseIcon name="share" size="18"></BaseIcon>
      </BaseButton>
      <ShareLinks
        :isActive="this.isActive"
        @toggled="toggleActive"
      ></ShareLinks>
    </div>
  </article>
</template>

<script>
import ShareLinks from './ShareLinks.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'CardArticle',
  components: { TextHeading, BaseButton, BaseIcon, ShareLinks },
  props: {
    title: {
      type: String,
      default: 'Article title goes here'
    },
    image: {
      type: String,
      default: 'carrier-bags.jpg'
    },
    date: {
      type: String,
      default: 'Today'
    },
    aria: {
      type: String,
      default: 'Read this News Article'
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    },
    getRadius() {
      return `${(this.rounded && 'article-block--rounded') || ''}`
    }
  },
  data() {
    return {
      isActive: false,
      makeActive: false
    }
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="postcss">
.headerVisible {
  @apply opacity-0;
}
.article-block {
  @apply flex-1 flex flex-col bg-primary-lightest overflow-hidden;
}
.article-block--rounded {
  @apply rounded-lg;
}
.article-block:hover {
  @apply cursor-pointer;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
}
.article-block:hover .article-block__image img {
  transform: scale(1.1);
}
.article-block a {
  @apply no-underline text-body flex-1;
  flex-basis: auto;
}
.article-block__image {
  @apply aspect-ratio-16/9 bg-body-dark relative overflow-hidden;
}
.article-block__image img {
  @apply block absolute inset-y-0 inset-x-0 w-full transition-slow;
}
.article-block__header {
  @apply p-6;
}
.article-block__sharer {
  @apply flex justify-between items-center relative pb-6 px-6;
}
.article-block__text {
  @apply pr-2 text-secondary font-semibold;
}
.article-block__button {
  @apply text-secondary;
}
.article-block__button:hover {
  @apply text-primary;
}
</style>
